var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtclender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    viewBox: "0 0 36 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1268,
    y: 0.0991211,
    width: 20.3881,
    height: 20.3881,
    fill: "#B55557"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34926 13.4279L15.1266 5.36035V20.487H0L7.34926 13.4279Z",
    fill: "#F88587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtclender);
export default __webpack_public_path__ + "static/media/btclender.bb00b4fc0cc736f9bb94d1e7ca4003c0.svg";
export { ForwardRef as ReactComponent };